import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../components/atoms/Button";
import AuthLayout from "../../../components/templates/AuthLayout";
import { requestEnd, requestStart, toast } from "../../../entities/app.entity";
import { fetchFromApi, handleFetchError } from "../../../services";
import { setCode } from "../../../entities/brand-invitation.enity";
import { t } from "i18next";
import { buildBrandInvitationSignupPath } from "./brandInvitation.helpers";

const VerifyBrandInvitation = () => {
  const navigate = useNavigate();

  const { code } = useParams();
  const verify = async () => {
    requestStart("verify");
    try {
      const { data } = await fetchFromApi({
        path: `partners/verify-invite/${code}`,
        method: "get",
      });
      if (data.message) {
        toast(data.message);
        setCode(code);
        if (data.data.partnerExist) {
          if (data.data.hasProduct) {
            navigate(
              `/auth/accept-brand-invitation/${data.data.PifId}?has_product=true`
            );
          } else {
            navigate(`/auth/accept-brand-invitation/${data.data.PifId}`);
          }
        } else {
          if (data.data.hasProduct) {
            navigate(`/auth/brand/${data.data.PifId}`);
          } else {
            navigate(buildBrandInvitationSignupPath(data.data));
          }
        }
      }
    } catch (error) {
      handleFetchError(error);
      // navigate("/auth/login");
    } finally {
      requestEnd();
    }
  };

  useEffect(() => {
    verify();
  }, [code]);

  return (
    <AuthLayout>
      <div>
        <Button buttonSize="large" label={t("Verifying.....")} />
      </div>
    </AuthLayout>
  );
};

export default VerifyBrandInvitation;
